<template>
  <transition>
    <!--公司历程 -->
    <div class="company_main_h">
      <div class="company_game_scroll">
        <div class="company_line">
          <img src="../assets/pcImg/year2023.png" alt/>
          <div class="company_piont_out">
            <div class="company_piont"
                 :style="{'left': index*moveY + 'rem'}"
                 :class="`p_${index+1}`"
                 v-for="(item, index) in 13" :key="index">
              <em></em>
            </div>
          </div>
        </div>
        <div class="company_game">
          <div class="game_list"
               :class="`game_list_${index+1}`"
               :style="{
                 'left': index*moveY + 'rem',
                 'animation-delay': (index + 1) * 0.6 + 's'
               }"
               v-for="(item, index) in history_list" :key="index"
               v-show="history"
          >
            <!-- <p>{{$t('m.company.game1')}}</p> -->
            <div class="game_title_item"
                 :style="{
            'top': (index + 1) % 2 === 0 ? '4.1rem' : '0.15rem'
          }"
                 v-html="item._html"></div>
            <div class="game_img_item"
                 :style="{
                    'transform': (index + 1) % 2 === 0 && item.icon !== 'rewardReverse' ? 'rotateX(180deg)' : 'rotateX(0deg)',
                    'top': (index + 1) % 2 === 0 ? '2.5rem' : '0.3rem',
                 }"
            >
              <img v-if="item.icon === 'hand'" src="../assets/pcImg/c1.png" alt/>
              <img v-else-if="item.icon === 'reward'" src="../assets/pcImg/c3.png" alt/>
              <img v-else-if="item.icon === 'rewardReverse'" src="../assets/pcImg/c6.png" alt/>
              <img v-else src="../assets/pcImg/c5.png" alt/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  name: "CompanyHistory",
  data() {
    return {
      history: true,
      history_list: [],
      moveY: 1.32
    };
  },
  methods: {},
  mounted() {
    this.history_list = [
      {
        _html: '<p>获得首轮投资<br/>正式开始海外手游发行业务</p>',
        icon: 'hand'
      },
      {
        _html: '<p>获得凯撒文化创投基金<br/>3000万 投资</p>',
        icon: 'hand'
      },
      {
        _html: '<p>获颁授苏州工业园区<br/>瞪羚培育企业</p>',
        icon: 'reward'
      },
      {
        _html: '<p>获颁授江苏省<br/>隐形小巨人企业</p>',
        icon: 'rewardReverse'
      },
      {
        _html: '<p>韩国子公司<br/>IClockwork Inc.正式成立</p>',
        icon: 'building'
      },
      {
        _html: '<p>荣获国家文化出口<br/>重点企业</p>',
        icon: 'rewardReverse'
      },
      {
        _html: '<p>获得江苏省<br/>重点软件培育企业</p>',
        icon: 'reward'
      },
      {
        _html: '<p>获得江苏省<br/>重点文化科技企业</p>',
        icon: 'rewardReverse'
      },
      {
        _html: '<p>新加坡子公司<br/>ICLOCKWORK PTE.LTD.正式成立</p>',
        icon: 'building'
      },
      {
        _html: '<p>荣获国家文化出口<br/>重点企业</p>',
        icon: 'rewardReverse'
      },
      {
        _html: '<p>入选国家文化出口<br/>重点项目</p>',
        icon: 'reward'
      },
      {
        _html: '<p>获颁授江苏省级<br/>服务贸易重点企业</p>',
        icon: 'rewardReverse'
      },
      {
        _html: '<p>荣获国家文化出口<br/>重点企业</p>',
        icon: 'reward'
      },
    ]
  },
  beforeDestroy() {
  },
};
</script>
<style scoped lang="scss">
.company_game_scroll {
  position: absolute;
  width: 17.7rem;
  height: 5.6rem;
  top: 3rem;
  left: calc(50% - 17.7rem / 2);
  overflow: hidden;
}

.game_title_item {
  position: relative;
}

.game_img_item {
  position: relative;

  img {
    width: 0.9rem;
  }
}

.company_main_h {
  width: 100%;
  height: 10.8rem;
  margin-top: -1rem;
  position: relative;
  background: url("../assets/pcImg/company/bg2.jpg") no-repeat;
  background-size: 100% 100%;

  .company_line {
    position: absolute;
    width: 17.7rem;
    height: 0.84rem;
    left: calc(50% - 8.73rem);
    top: 1.6rem;

    img {
      width: 100%;
    }
  }

  .company_piont_out {
    position: relative;
    left: 0.9rem;
    top: -0.71rem;
  }

  .company_piont {
    position: absolute;
    width: 0.05rem;
    height: 0.05rem;
    border-radius: 100%;
    background: #fff;

    em {
      display: inline-block;
      position: absolute;
      // width: 3px;
      // height: 3px;
      width: 0.03rem;
      height: 0.03rem;
      border-radius: 100%;
      border: 1px solid #ccc;
      background: #fff;
    }

    &::before {
      content: "";
      position: absolute;
      width: 0.29rem;
      height: 0.29rem;
      left: -.12rem;
      top: -.12rem;
      z-index: 12;
      border-radius: 100%;
      background-image: radial-gradient(
                      white 5%,
                      rgba(255, 255, 255, 0.1) 50%,
                      rgba(255, 255, 255, 0) 65%
      );
      animation: move ease infinite 1.5s;
    }
  }

  @keyframes move {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.2);
    }
    100% {
      transform: scale(1);
    }
  }
  .company_game {
    color: white;
    font-size: 0.14rem;

    .game_list {
      width: 2.1rem;
      height: 2.1rem;
      position: absolute;
      text-align: center;
      animation-duration: 0.5s;
      animation-fill-mode: both;
      animation-name: fadeInTop;
    }
    .fadeIndown {
      animation-duration: 0.5s;
      animation-fill-mode: both;
      animation-name: fadeInBottom;
    }

    @keyframes fadeInTop {
      from {
        opacity: 0;
        transform: translate3d(0, -15%, 0);
        -webkit-transform: translate3d(0, -15%, 0);
        -moz-transform: translate3d(0, -15%, 0);
        -ms-transform: translate3d(0, -15%, 0);
        -o-transform: translate3d(0, -15%, 0);
      }
      to {
        opacity: 1;
        transform: none;
        -webkit-transform: none;
        -moz-transform: none;
        -ms-transform: none;
        -o-transform: none;
        transform: none;
      }
    }
    @keyframes fadeInBottom {
      from {
        opacity: 0;
        transform: translate3d(0, 15%, 0);
        -webkit-transform: translate3d(0, 15%, 0);
        -moz-transform: translate3d(0, 15%, 0);
        -ms-transform: translate3d(0, 15%, 0);
        -o-transform: translate3d(0, 15%, 0);
      }
      to {
        opacity: 1;
        transform: none;
        -webkit-transform: none;
        -moz-transform: none;
        -ms-transform: none;
        -o-transform: none;
        transform: none;
      }
    }

    p {
      margin: 0.15rem 0;
    }
  }

}
</style>
